export default "__VITE_ASSET__NDGZzJgP__"